<template>
  <div
    class="relative flex items-center justify-center text-primary-2 overflow-hidden rounded-full p-px"
    :class="wrapperSizeClass"
  >
    <div class="spinner"></div>
    <div
      v-if="countdown"
      class="absolute text-center leading-none"
      :class="textSizeClass"
    >
      <span class="digit font-bold">{{ countdown }}</span>
      <span class="min font-bold"> {{ label }} </span>
      <p class="sub">verbleiben</p>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  countdown: {
    type: String,
    default: undefined,
  },
  label: {
    type: String,
    default: undefined,
    validator: (value) => {
      return ['min', 's'].includes(value);
    },
  },
  size: {
    type: String,
    default: 'is-small',
  },
});

const wrapperSizeClass = computed(() => {
  switch (props.size) {
    case 'is-medium':
      return 'w-[200px] h-[200px]';
    case 'is-large':
      return 'w-[400px] h-[400px]';
    default:
      return 'w-[120px] h-[120px]';
  }
});

const textSizeClass = computed(() => {
  switch (props.size) {
    case 'is-medium':
      return 'text-[14px]';
    case 'is-large':
      return 'text-[20px]';
    default:
      return 'text-[8px]';
  }
});
</script>
<style scoped lang="scss">
.spinner {
  position: relative;
  height: 100%;
  width: 100%;
  border-radius: 50%;
  background: conic-gradient(transparent, currentColor);
  animation: rotate 2s linear infinite;
  animation-direction: reverse;
  will-change: transform;
  contain: paint;
}
.spinner:before,
.spinner:after {
  content: '';
  position: absolute;
  border-radius: 50%;
}
.loading-text {
  .digit {
    font-size: 3em;
  }
  .min {
    font-size: 2em;
  }
  .sub {
    font-size: 1.3em;
  }
}
.spinner:before {
  width: 70%;
  height: 70%;
  top: 15%;
  left: 15%;
  background-color: #ffffff;
}
.spinner:after {
  height: 15%;
  width: 15%;
  background-color: currentColor;
  top: 0;
  left: 42.5%;
}
@keyframes rotate {
  from {
    transform: rotateZ(360deg);
  }
  to {
    transform: rotateZ(0);
  }
}
</style>
